export default __webpack_public_path__ + "static/media/newPc.d638358c.svg";